<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage trips</div>
            <fieldset class="border p-3">
              <div></div>
              <div>
                <div class="tripsLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading trips...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemTrips"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'trip_status'">
                      <span v-if="props.row.trip_status === 0">
                        <button class="btn btn-danger btn-sm btn-flat">
                          <i class="fa fa-level-up"></i> ONGOING
                        </button>
                      </span>
                      <span v-else-if="props.row.trip_status === 1">
                        <button class="btn btn-success btn-sm">
                          <i class="fa fa-level-down"></i>COMPLETED
                        </button>
                      </span>
                    </span>
                    <span v-else-if="props.column.field == 'payment_status'">
                      <span v-if="props.row.payment_status === 0">
                        <button class="btn btn-danger btn-sm btn-flat">
                          <i class="fa fa-level-up"></i> NOT PAID
                        </button>
                      </span>
                      <span v-else-if="props.row.payment_status === 1">
                        <button class="btn btn-success btn-sm">
                          <i class="fa fa-level-down"></i>PAID
                        </button>
                      </span>
                    </span>
                    <span v-else-if="props.column.field == 'Commission'">
                      <span v-if="props.row.payment_status === 0">
                        <button
                          class="btn btn-primary btn-sm btn-flat"
                          @click="viewCommission(props.row.id)"
                        >
                          <i class="fa fa-plus"></i> Add commission
                        </button>
                      </span>
                      <span v-else-if="props.row.payment_status === 1">
                        <button class="btn btn-success btn-sm">
                          <i class="fa fa-level-down"></i>COMMISSION CLOSED
                        </button>
                      </span>
                    </span>
                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Truck name",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Loading Date",
          field: "loading_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Consignee name",
          field: "consignee_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Cfs name",
          field: "cfs_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Trip status",
          field: "trip_status",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Payment status",
          field: "payment_status",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Commission",
          field: "Commission",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadTrips();
  },
  computed: {
    ...mapGetters(["systemTrips"]),
  },
  methods: {
    ...mapActions(["newTrip", "loadTrips", "viewCommission"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/trips/managetrips.vue